import React from 'react';
import classNames from 'classnames';

const Alert = ({ type, children }) => {
    const classes = classNames({
        'alert': true,
        [`alert-${type}`]: true,
    });
    return <div className={classes}>{children}</div>;
};

export default Alert;



// WEBPACK FOOTER //
// ./src/incab/common/components/Alert.jsx